export const buildPromoStoreDetailsPath = (instanceUniqueId, promoStoreId, tab = "reports") =>
  `/instance/${instanceUniqueId}/sales/promostores/${promoStoreId}/${tab}`;

export const buildPromoStoreProductReportPath = (instanceUniqueId, promoStoreId) =>
  `/instance/${instanceUniqueId}/sales/promostores/${promoStoreId}/reports/products`;
